export const ES_COUNTRY = 'es'
export const MX_COUNTRY = 'mx'
export const ES_PREFIX = 34
export const MX_PREFIX = 521


// WEBPACK FOOTER //
// ./src/constants/countries.js